import { FeatureHubGuard } from "@/featureFlags";
import { Button } from "@/overlay/components/CommonParts/buttons";
import { GeoJSONManage } from "@/overlay/components/GeoJSONManage";
import { CustomGeoJsonFileSelect } from "@/overlay/components/LayerStackWindow/CustomGeoJsonForm/CustomGeoJsonFileSelect";
import { Modal } from "@/overlay/components/window/Modal";
import { Trans } from "@lingui/react/macro";
import type { ModelFile as CustomGeoJSONFile, CustomGeoJSONLayerOutput } from "@mm/metx-workbench.meteomatics.com";
import { useState } from "react";
import styles from "./style.module.scss";

type CustomGeoJsonCreateFormProps = {
  onChange: (propsValue: Partial<CustomGeoJSONLayerOutput>) => void;
  customGeoJsonList: CustomGeoJSONFile[];
  selectedGeoJsonFileId?: number | null;
};

export function CustomGeoJsonCreateForm({
  onChange,
  customGeoJsonList,
  selectedGeoJsonFileId,
}: CustomGeoJsonCreateFormProps) {
  const [showGeoJSONManageWindow, setShowGeoJSONManageWindow] = useState(false);

  return (
    <>
      <CustomGeoJsonFileSelect
        selectedFileId={selectedGeoJsonFileId}
        list={customGeoJsonList}
        onChange={(user_file_id) => {
          onChange({ user_file_id: user_file_id });
        }}
      />
      <FeatureHubGuard flag="upload_window">
        <div className={styles["button-right"]}>
          <Button icon="upload" onClick={() => setShowGeoJSONManageWindow(true)}>
            <Trans>Upload new</Trans>
          </Button>
        </div>
        <Modal isOpen={showGeoJSONManageWindow} onClose={() => setShowGeoJSONManageWindow(false)}>
          <GeoJSONManage />
        </Modal>
      </FeatureHubGuard>
    </>
  );
}
